import { render, staticRenderFns } from "./EmailResetPasswordComponent.vue?vue&type=template&id=4f292630"
import script from "./EmailResetPasswordComponent.js?vue&type=script&lang=js&external"
export * from "./EmailResetPasswordComponent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports